import _ from 'lodash';
import { Steps, StepActions } from '../../../components/common/wizard/logic';
import EventInfo from '../components/eventInfo';
import EventDetails from '../components/eventDetails';
import LaneConditions from '../components/laneConditions';
import EventRules from '../components/rules';
import EventDeposit from '../components/deposit';
import Setup from '../components/setup';
import SetupComplete from '../components/setupComplete';
import { wizardSteps, STEP_SEQUENCE } from './';

export const getSteps = function(lastStep, lastStepCompleted) {
    const steps = new Steps();
 
    wizardSteps.map((step) => {
				const { label,sequence } = step;
		
				const currentStep = ((lastStep > 0) && (lastStep === sequence)) ? true:false;
				let currentStepDisabled = true;
				let currentStepCompleted = false;

				if((sequence <= lastStepCompleted) && (!currentStep))
				{
					currentStepDisabled = false;
					currentStepCompleted = true;
				}
        steps.add(label,currentStep,currentStepDisabled,currentStepCompleted,sequence);
		})
		return steps;
}

export const getWizardComponent = function(currentStep) {
	switch(currentStep) {
		case(STEP_SEQUENCE.EventInfo):
		{
			return EventInfo; 
		}
		case(STEP_SEQUENCE.EventDetails):
		{
			return EventDetails;
		}
		case(STEP_SEQUENCE.LaneConditions):
		{
			return LaneConditions;
		}
		case(STEP_SEQUENCE.Rules):
		{
			return EventRules;
		}
		case(STEP_SEQUENCE.Setup):
		{
			return Setup;
		}
		case(STEP_SEQUENCE.Deposit):
		{
			return EventDeposit;
		}
		case(STEP_SEQUENCE.SetupComplete):
		{
			return SetupComplete;
		}
	}
}

export const goToStep = function(stepAction, wizardsteps, step) {
	// step is the step in the wizard to go to
	const steps = [...wizardsteps];

	// update current and next steps accordingly
	const currentStep = _.find(steps, { 'current': true });
	currentStep.completed = true;
	currentStep.current   = false;
	currentStep.disabled  = false;
	const currentSequence = currentStep.sequence

	let next=0;

	switch(stepAction) {
		case(StepActions.Previous):
		{
			next = currentSequence - 1;
			break;
		}
		case(StepActions.Next):
		{
			next = currentSequence + 1;
			break;
		}
		case(StepActions.GoTo):
		{
			next = parseInt(step,10); 
			break;
		}
	}
	const nextStep = _.find(steps, { 'sequence': next });
	if (nextStep !== undefined){
		nextStep.completed = false;
		nextStep.current   = true;
		nextStep.disabled  = false;
	}
	else{
		next=1;
	}

	return {
		steps,
		next,
	}
}




// WEBPACK FOOTER //
// ./src/containers/event/logic/wizard.js